"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectLocale = void 0;

const selectLocale = state => state.get('locale', 'en');

exports.selectLocale = selectLocale;